export default {"src":"/_next/static/media/Off-Balance-Sheet.32b0387d.svg","height":154,"width":192};